/**
 * This module is concerned with working on "data" or the normal form
 * of data in JavaScript; an array of objects of the form Record<string, any>.
 */
import { countBy } from 'lodash';
/**
 * Given an array of objects, return any duplicates
 */
export function detectDuplicates(data, property) {
    const counts = countBy(data, property);
    const duplicates = Object.entries(counts).filter(([_, v]) => v > 1);
    return duplicates.length > 0 ? Object.fromEntries(duplicates) : null;
}
